var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "justify-center align-middle" },
    [
      _c(
        "el-col",
        [
          _c("el-card", { staticClass: "card", attrs: { shadow: "hover" } }, [
            _c(
              "div",
              { staticClass: "text-center" },
              [
                _vm.dadosDocumento.tipo.codigo === "ART_TRT"
                  ? _c("p", { staticClass: "info" }, [
                      _vm._v(
                        "Nome do documento: Anotação de Responsabilidade Técnica - ART"
                      )
                    ])
                  : _vm._e(),
                _vm._t("baixar"),
                _c("el-row", { staticClass: "dados-doc justify-center" }, [
                  _c(
                    "div",
                    { staticClass: "link-download" },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: "cloud-download-alt" }
                      }),
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.downloadDoc(_vm.dadosDocumento.id)
                            }
                          }
                        },
                        [_vm._v("  Baixar Documento")]
                      )
                    ],
                    1
                  )
                ])
              ],
              2
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-773c44c1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-773c44c1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/DownloadDocumento.vue
// module id = null
// module chunks = 